// Enum-like constant for categories
export const CATEGORIES = [
  { key: "2W", label: "2 Wheelers" },
  { key: "3W", label: "3 Wheelers" },
  { key: "4W", label: "4-Wheelers" },
  { key: "Others", label: "Others" },
];
